import { Component, inject } from '@angular/core';
import { ObjectType, COMPANY_PROFILE_CARD_DATA_TOKEN } from '../../../tokens-and-interfaces';
import { CustomObjectAssociationsComponent } from '../custom-object-associations-panel/custom-object-associations.component';

@Component({
  selector: 'crm-company-to-custom-object-associations-card',
  template: `<crm-custom-object-associations
    [id]="id"
    [name]="name"
    [objectType]="objectType"
  ></crm-custom-object-associations>`,
  imports: [CustomObjectAssociationsComponent],
  providers: [],
})
export class CompanyToCustomObjectAssociationsCardComponent {
  data = inject(COMPANY_PROFILE_CARD_DATA_TOKEN);
  id = this.data?.company_id || '';
  name = this.data?.name || '';
  objectType: ObjectType = 'Company';
}
